import styled from "styled-components";

import { Nav } from "@olist/design-system";

export const AccordionSubHeaderWrapper = styled.div`
  border-radius: 8px;
  margin-left: 5px;
  padding: 10px;
`;

export const Title = styled.div`
  align-items: center;
  color: #000;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: bold;
`;

export const Icon = styled.span<{ isOpen: boolean }>`
  margin-right: 10px;
  transform: rotate(${(props) => (props.isOpen ? "180deg" : "0deg")});
  transition: transform 0.3s ease;
`;

export const ListItem = styled.li<{ listStyle: string }>`
  color: ${({ theme }) => theme.olist.color.primary.base};
  list-style-position: inside;
  list-style-type: ${({ listStyle }) => listStyle || "disc"};
`;

export const StyledNav = styled(Nav)`
  background-color: transparent;
  color: ${({ theme }) => theme.olist.color.primary.base};
  font-size: 14px;

  padding: 0;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
